import Splide from '@splidejs/splide';
function initLightbox(gallery) {
    const { dataset } = gallery;
    const { mode } = dataset;
    let block = null;
    switch (mode) {
        case 'masonry':
            block = 'image-masonry';
            break;
        case 'slider':
            block = 'image-slider';
            break;
        case 'grid':
            block = 'image-grid';
            break;
        case undefined: {
            throw new Error('Not implemented yet: undefined case');
        }
    }
    if (block === null) {
        return;
    }
    const dialog = gallery.querySelector('.image-lightbox');
    if (!dialog)
        return;
    const lightboxSlider = dialog.querySelector('.image-lightbox__slider');
    const zoomBtns = Array.from(gallery.querySelectorAll(`.${block}__zoom-btn`));
    const closeBtn = dialog.querySelector('.image-lightbox__close');
    let splide = null;
    let triggerBtn = null;
    const getSplide = () => {
        if (!splide && lightboxSlider) {
            const { dataset } = lightboxSlider;
            const prev = dataset['i18nPrev'] ?? '';
            const next = dataset['i18nNext'] ?? '';
            // In loop mode Splide labels the arrows with first/last at the ends
            splide = new Splide(lightboxSlider, {
                i18n: {
                    prev,
                    next,
                    first: next,
                    last: prev,
                    carousel: dataset['i18nCarousel'] ?? '',
                    slide: dataset['i18nSlide'] ?? '',
                    slideLabel: dataset['i18nSlideLabel'] ?? '',
                },
                type: 'loop',
                autoplay: false,
                drag: true,
                pagination: false,
                keyboard: 'global',
            });
            splide.mount();
        }
        return splide;
    };
    zoomBtns.forEach((btn) => {
        btn.addEventListener('click', () => {
            triggerBtn = btn;
            dialog.showModal();
            const s = getSplide();
            if (!s) {
                return;
            }
            const originalSpeed = (s.options.speed ?? 400);
            s.options = { speed: 0 };
            s.go(Number(btn.dataset['index'] ?? 0));
            requestAnimationFrame(() => { s.options = { speed: originalSpeed }; });
        });
    });
    closeBtn?.addEventListener('click', () => { dialog.close(); });
    dialog.addEventListener('close', () => triggerBtn?.focus());
}
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-component="ImageGallery"]').forEach(initLightbox);
});
